export default __webpack_public_path__ + "media/images/planification-vert-63bfda2bcce59fe6b6657eae67e372a8.png";